function MessageTransformer(message) {
    if(message.type == 'raw' && message.content?.context == 'play_action') {
        return message.content.values.url.map((content) => { return { content : content, type : 'audio', view : 0 }})
    }

    const regex = /[a-zA-Z0-9][a-zA-Z0-9-]+[a-zAZ0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,}/g;
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const result = message.content.match(regex);

    if (result != null) {
        result.forEach((value, index) => message.content = message.content.replace(value, '{' + index + '}'));
    }

    const bubbleSplitRegex = /(?<=[.!?-])\s+/;
    const bubblesArray = message.content.split(bubbleSplitRegex);
    const bubbles = bubblesArray.map(sentence => sentence.trim())
        .map(sentence => sentence.replace(/\{(.*?)\}/g, match => {
            const sentenceWithoutBraces = result[match[1]];
            // Supprimer le point à la fin du message s'il y en a un , à la demande Pascal
            if (sentenceWithoutBraces.endsWith('.')) {
                return sentenceWithoutBraces.slice(0, -1);
            }
            return sentenceWithoutBraces;
        }))
        .filter(bubble => bubble != '')
        .map(sentence => {
            // Supprimer le point à la fin de chaque bulle si nécessaire , à la demande Pascal
            if (sentence.endsWith('.')) {
                return sentence.slice(0, -1);
            }
            return sentence;
        })
        .map(sentence => {

            if (!sentence.match(urlRegex)) {
                return sentence.charAt(0).toUpperCase() + sentence.slice(1);
            }

            return sentence;
        });

    const regexImg = /(<img[^>]*src="[^"]+"[^>]*>)/;
    var bubblesSplit = [];
    let currentBubblesSplit = "";

    bubbles.forEach(bubble => {
        if (bubble.match(regexImg)) {
            currentBubblesSplit += bubble;
        } else {
            if (currentBubblesSplit) {
                bubblesSplit.push({ content: currentBubblesSplit, type: message.type, view: 0 });
                currentBubblesSplit = "";
            }
            bubblesSplit.push({ content: bubble, type: message.type, view: 0 });
        }
    });

    if (currentBubblesSplit) {
        bubblesSplit.push({ content: currentBubblesSplit, type: message.type, view: 0 });
    }

    return bubblesSplit;
}

const MessagesTransformer = (messages) => {
    var messageSplit = [];
    messages = messages?.filter(msg => msg.type != 'raw' || (msg.type == 'raw' && msg.content?.context == 'play_action'));
    messages?.forEach(message =>  messageSplit = [...messageSplit, ...MessageTransformer(message)]);
    return messageSplit;
}
  
export default MessagesTransformer;
